import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-[90%] md:w-[350px] mx-auto py-14" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-8 text-4xl font-bold text-center text-primary-500 lg:text-5xl" }, "Sign Up", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = { class: "mb-5" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = { class: "mb-5" }
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "mb-5" }
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = { class: "mb-5" }
const _hoisted_12 = { class: "mb-5" }
const _hoisted_13 = { class: "mb-8" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "agree",
    class: "block text-sm leading-5 text-darkgray-400"
  }, [
    /*#__PURE__*/_createTextVNode(" By clicking “Sign Up”, I hereby agree with Shinagawa’s "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://shinagawa.ph/data-privacy-notice/",
      target: "_blank",
      class: "text-sm text-primary-500"
    }, "Terms and Conditions"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://shinagawa.ph/data-privacy-notice/",
      target: "_blank",
      class: "text-sm text-primary-500"
    }, "Privacy Policy"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_15 = { class: "flex flex-wrap justify-center mb-10" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8 text-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-darkgray-400" }, [
    /*#__PURE__*/_createTextVNode("Already have an account yet? "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "/login",
      class: "font-bold text-primary-500"
    }, "Login now")
  ])
], -1)

import { ref, onMounted } from "vue";
import { useRouter, useRoute } from 'vue-router';
import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';
// import BirthdayPicker from '@/components/inputs/BirthdayPicker.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import GeneralModal from '@/components/GeneralModal.vue';
// import SelectOptions from "@/components/inputs/SelectOptions.vue";
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import CalendarPicker from "@/components/CalendarPicker.vue";
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';

import AuthService from "@/classes/AuthService";
import patient from "@/classes/UserData";

import { numberonly } from "@/helpers/NumberHelper";
import { VueRecaptcha } from 'vue-recaptcha';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignUp',
  setup(__props) {

const router = useRouter();
const route = useRoute()
const show = ref(false);
const errorMsg = ref()
const showError = ref(false)
const loader = ref(false);
const errors = ref([]);
const siteKey = process.env.VUE_APP_SITE_KEY;
const disableEmail = ref(false);

const form = ref({
    suffix: null,
    email: null,
    first_name: null,
    middle_name: null,
    last_name: null,
    date_of_birth: null,
    sex: null,
    mobile_number: null,
    password: null,
    password_confirmation: null,
    terms_agreed: null,
    grecaptcha: null,
});

const genderOpt = patient.getGender()

const verify = (response) => { 
    form.value.grecaptcha = response;
}

const expiredRecaptcha = () => {
    form.value.grecaptcha = null;
}

const submit = () => {
    loader.value = true;

    AuthService.register(form.value)
    .then( () => {
        show.value = true;
        loader.value = false;

        setTimeout(() => {
            show.value = false;
            router.push('/login')
        }, 30000);

    }).catch( (err : any) => {
        loader.value = false;
        showError.value = true;
        errorMsg.value = err.response.data.message;

        if(err.response.status == 422) {
            errors.value = err.response.data.errors;
        }
    })
}

onMounted(() => {

    if('email' in route.query){
        form.value.email  =route.query.email
        disableEmail.value = true
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(submit, ["prevent"])
        }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(TextInput, {
              type: "text",
              placeholder: "First Name",
              modelValue: form.value.first_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.first_name) = $event)),
              error: errors.value.first_name ? errors.value.first_name[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              type: "text",
              placeholder: "Middle Name",
              modelValue: form.value.middle_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.middle_name) = $event)),
              error: errors.value.middle_name ? errors.value.middle_name[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(TextInput, {
              type: "text",
              placeholder: "Last Name",
              modelValue: form.value.last_name,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.last_name) = $event)),
              error: errors.value.last_name ? errors.value.last_name[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(TextInput, {
              name: "reg_suffix",
              id: "reg_suffix",
              type: "text",
              placeholder: "Suffix",
              modelValue: form.value.suffix,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.suffix) = $event)),
              error: errors.value.suffix ? errors.value.suffix[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(CalendarPicker, {
              placeholder: "Date of Birth",
              modelValue: form.value.date_of_birth,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.date_of_birth) = $event)),
              inline: false,
              error: errors.value.date_of_birth ? errors.value.date_of_birth[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(MultiselectInput, {
              name: "gender",
              id: "gender",
              modelValue: form.value.sex,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.sex) = $event)),
              placeholder: "Gender",
              options: _unref(genderOpt),
              error: errors.value.sex ? errors.value.sex[0] : ''
            }, null, 8, ["modelValue", "options", "error"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(TextInput, {
              type: "email",
              modelValue: form.value.email,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.email) = $event)),
              placeholder: "Email",
              error: errors.value.email ? errors.value.email[0] : '',
              disabled: disableEmail.value
            }, null, 8, ["modelValue", "error", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(TextInput, {
              add_on_left: true,
              add_on_text: "+63",
              onKeypress: _unref(numberonly),
              placeholder: 'Mobile Number',
              maxlength: "10",
              modelValue: form.value.mobile_number,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.mobile_number) = $event)),
              error: errors.value.mobile_number ? errors.value.mobile_number[0] : ''
            }, null, 8, ["onKeypress", "modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(PasswordInput, {
              id: "password",
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.password) = $event)),
              placeholder: "Password",
              helper: "",
              error: errors.value.password ? errors.value.password[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(PasswordInput, {
              id: "confirm_password",
              modelValue: form.value.password_confirmation,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.password_confirmation) = $event)),
              placeholder: "Confirm Password",
              error: errors.value.password_confirmation ? errors.value.password_confirmation[0] : ''
            }, null, 8, ["modelValue", "error"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(CheckboxInput, {
              id: "agree",
              modelValue: form.value.terms_agreed,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.terms_agreed) = $event)),
              error: errors.value.terms_agreed ? errors.value.terms_agreed[0] : '',
              "default-slot": false
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["modelValue", "error"]),
            (errors.value.terms_agreed)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["text-[10px] mt-1", errors.value.terms_agreed ? 'text-red-600' : 'text-gray-800']),
                  id: "terms_agreed-error"
                }, _toDisplayString(errors.value.terms_agreed[0]), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(VueRecaptcha), {
              sitekey: _unref(siteKey),
              ref: "grecaptcha",
              onVerify: verify,
              onExpired: expiredRecaptcha
            }, null, 8, ["sitekey"]),
            (errors.value.grecaptcha)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["text-[10px] mt-1 w-full text-center", errors.value.grecaptcha ? 'text-red-600' : 'text-gray-800']),
                  id: "grecaptcha-error"
                }, _toDisplayString(errors.value.grecaptcha[0]), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(ButtonComponent, {
              disabled: loader.value,
              type: 'submit',
              text: "Sign Up"
            }, null, 8, ["disabled"])
          ])
        ], 32),
        _hoisted_17
      ]),
      _createVNode(GeneralModal, {
        width: "w-[416px]",
        title: "Congratulations!",
        content: "Your account has been successfully created. Kindly verify your account through the link we sent to your email.",
        "action-text": "Login",
        show: show.value,
        onClose: _cache[11] || (_cache[11] = ($event: any) => (show.value = false)),
        onConfirm: _cache[12] || (_cache[12] = ($event: any) => {_unref(router).push('/login'); show.value = false})
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[14] || (_cache[14] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})